import React from 'react';
import { MDBDataTable } from 'mdbreact';
import dayjs from 'dayjs';
import { Button } from 'reactstrap';
import usePatch from '../../../helpers/hooks/usePatch';

const columns = [
  {
    label: 'Image',
    field: 'profilePicture',
    sort: 'disabled',
    width: 150,
  },
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
    width: 270,
  },
  
  {
    label: 'Age',
    field: 'age',
    sort: 'asc',
    width: 200,
  },
  {
    label: 'Language',
    field: 'language',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'Gender',
    field: 'gender',
    sort: 'asc',
    width: 150,
  },
  {
    label: 'Date of Joining',
    field: 'createdAt',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'District',
    field: 'district',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'Rabi Crops',
    field: 'rabiCrops',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'Khareef Crops',
    field: 'khareefCrops',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'Ownership',
    field: 'ownership',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'Actions',
    field: 'actions',
    sort: 'disabled',
    width: 100,
  },
];
const FarmersList = (props) => {
  


  return (
    <>
      <MDBDataTable
        btn
        responsive
        bordered
        data={{
          columns: columns,
          rows: props?.farmers?.map((x) => ({
            name: x.name,
            pacakages:x.pacakages,
            profilePicture: (
              <img
                src={x.profilePicture}
                className='rounded-circle avatar-sm card-img'
              />
              
            ),
            phone: x.phone,
            createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
            actions: (
              <>
              <Button color='info' size='sm' onClick={() => props.editFarmer(x)}>
                View
              </Button>
              
              <Button color='primary' size='sm'  style={{marginTop:"3px", marginLeft:"-3px"}}  onClick={()=> props.onStatusChange(x, !x.packages)}> 
              { x.packages ? 'Deactivate' : 'Activate'}
              </Button>
              </>
            ),
            district: x.district?.name,
            language: x.language?.title,
            age: x.age,
            gender: x.gender,
            ownership: x.ownership?.join(', '),
            rabiCrops: x.rabiVegetables?.map((x) => x.name).join(', '),
            khareefCrops: x.khareefVegetables?.map((x) => x.name).join(', '),
            // vegetables: x.vegetables.map((z) => z.name).join(', '),
          })),
        }}
      />
    </>
  );
};

export default FarmersList;
